import { render } from "./ListePaiementService.vue?vue&type=template&id=4b3c755d&ts=true"
import script from "./ListePaiementService.vue?vue&type=script&lang=ts"
export * from "./ListePaiementService.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__